<template>
    <div>
      <trademark-status-list></trademark-status-list>
    </div>
  </template>
  
  <script>
  
  export default {
  }
  </script>
  
  
  